import { request } from 'graphql-request';
import { API_URL, APP_DOMAIN } from 'appenv';

const fetchExhibitorsByKeywordQuery = `
  query fetchExhibitorsByKeyword(
    $domain: String!,
    $afterCursor: String,
    $keyword: String,
    $limit: Int,
    $locales: [Locale!]!,
  ) {
    eventByDomain(domain: $domain) {
      id
      searchByKeyword(
        keyword: $keyword
        first: $limit
        after: $afterCursor
      ) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            searchable {
            ... on Booth {  
              id
              appliedDesignCodename
              logo {
                values(locales: $locales) {
                  locale
                  value {
                    originalImageUrl
                  }
                }
              }
              name {
                values(locales: $locales) {
                  locale
                  value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

function fetchExhibitorsByKeyword(afterCursor, keyword, limit, locales) {
  return request(API_URL, fetchExhibitorsByKeywordQuery, {
    domain: APP_DOMAIN,
    afterCursor,
    keyword,
    limit,
    locales,
  }).then((result) => {
    const { eventByDomain: { searchByKeyword } } = result;
    return searchByKeyword;
  });
}

export default fetchExhibitorsByKeyword;
